const IS_DEV = process.env.NODE_ENV === 'development'

const subpath = `${process.env.REACT_APP_SUBPATH}`

const myDomain = !IS_DEV ?
    `https://${process.env.REACT_APP_MY_DOMAIN}` :
    ``

const cloudFunctionName = process.env.REACT_APP_FUNCTION_NAME

const cloudFunctionHTTP = process.env.REACT_APP_FUNCTION_HTTP

/**
 * 平台相关配置
 */
const appConfig = {
    IS_DEV,
    // 子路径
    subpath,
    // 部署所在域名
    myDomain,
    // 部署路径（配合process.env.PUBLIC_URL，可获得完整的资源路径）
    deployUrl: `${myDomain}/${subpath}`,
    // 开发商
    com: 'com.logix',
    // 应用名称
    appName: '苏州丝绸博物馆',
    // 腾讯云函数HTTP
    cloudFunctionHTTP: `//${cloudFunctionHTTP}/${cloudFunctionName}`,
    // 屏幕高宽比和ip6的比例
    ip6Ratio: (window.innerHeight / window.innerWidth) / 1.608
}

export default appConfig